/**
 * White-label: reemplaza "Chatwoot" por el nombre de instalación (INSTALLATION_NAME)
 * en TODOS los strings de i18n, vía el hook `postTranslation` de vue-i18n.
 *
 * `window.globalConfig` se inyecta en el layout (app/views/layouts/vueapp.html.erb)
 * antes de montar la app, así que está disponible sincrónicamente.
 *
 * Se aplica en los entrypoints (v3app = login/signup, dashboard = app de operadores).
 */
export const brandingPostTranslation = translated => {
  if (typeof translated !== 'string') return translated;
  const name = window.globalConfig?.INSTALLATION_NAME;
  return name ? translated.replace(/Chatwoot/g, name) : translated;
};
